<template>
  <div id="UserView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> User View</div>
          <div class="web-action-btn btn-groups text-right">
            <router-link title="Edit User"  class="btn btn-primary" v-bind:to="{name: 'UserEdit',params:{id:$route.params.id}}"><i class="fp-edit-icon"> </i> Edit</router-link>
            <router-link class="btn btn-secondary pull-right ml-1" v-bind:to="{name: 'UserList'}" > <i class="fp-back"></i> Back</router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content user-detail list-view">
            <div id="tabs" class="containerTab mt-4">
              <div class="tabs">
                <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">User Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
              </div>
              <div class="content">
                <div v-show="activetab === 1" class="tabcontent">
                  <div class="list-sections">
                    <div class="form-row section-divider" style="border-bottom:0px;">
                      <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Name :</label>
                            <span class="col">{{name}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Email :</label>
                            <span class="col">{{email}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Phone :</label>
                            <span class="col">{{work_phone}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">User Type :</label>
                            <span class="col">{{usertype}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Role :</label>
                            <span class="col">{{role}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Job Title :</label>
                            <span class="col">{{job_title}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Joining Date :</label>
                            <span class="col">{{joining_date}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Address 1 :</label>
                            <span class="col">{{address_1}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Address 2 :</label>
                            <span class="col">{{address_2}}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Employee No :</label>
                            <span class="col">{{employee_no}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Hourly {{ labor_spelling }} Rate :</label>
                            <span class="col">{{hourly_labor_rate}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Shift Hours :</label>
                            <span class="col">{{shift_hours}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">User Name :</label>
                            <span class="col">{{username}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Location :</label>
                            <span class="col">{{location}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">City :</label>
                            <span class="col">{{city}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">State :</label>
                            <span class="col">{{state}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Zip :</label>
                            <span class="col">{{zip}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">License No :</label>
                            <span class="col">{{license_no}}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                    <user-activity-log-list :activityLogVal="activityLogsTabValue"></user-activity-log-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
    import Vue from "vue";

    
    import {commonMixins} from '../mixins/commonMixins';
    import ActivityLogListView from '@/components/ActivityLogList.vue';
    Vue.component("user-activity-log-list", ActivityLogListView);
    
    export default {
      name: "UserView",
      mixins:[commonMixins],
      data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        userId:'',
        activetab: 1,
        activityLogsTabValue: "dontLoadList",
        activityLoaded:false,
        name : '',
        username:'',
        email:"",
        phone:'',
        role:"",
        usertype:"",
        location:"",
        city:"",
        state:"",
        address_1:"",
        address_2:"",
        job_title:"",
        joining_date: "",
        license_no :"",
        zip:"",
        hourly_labor_rate:"",
        employee_no:"",
        shift_hours:"",
      }),
      watch: {
        //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_user') {
                            self.cantAccessPage = true;
                            self.canUpdateUser = true;
                        }
                    }
                }

            }
      },
      mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadUserDetails();
        var pathUrl = window.location.pathname;
        var segments = pathUrl.split("/");
        self.userId=segments[3];
      },
      metaInfo() {
        return{
                title: (this.userId != "")? this.userId + "  User View | " +process.env.COPYRIGHT_NAME:"User View | " +process.env.COPYRIGHT_NAME
            }
      },
      methods: {
        loadUserDetails() {
          var path = window.location.pathname;
          var segments = path.split("/");
          var self = this;
          self.loading = true;
          $.ajax({
                    url: process.env.ROOT_API + "/user/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.name=data.content.first_name;
                            self.username= data.content.username;
                            self.email = data.content.email;
                            self.phone =  data.content.phone;
                            self.work_phone =  data.content.work_phone;
                            self.role = self.titleCase(data.content.roles[0].name);
                            self.usertype = self.titleCase(data.content.type);
                            self.location = data.content.locationCode+" | "+data.content.locationName;
                            self.city = data.content.cityName;
                            self.state = data.content.stateName;
                            self.address_1 = data.content.address_1;
                            self.address_2 = data.content.address_2;
                            self.job_title = data.content.job_title;
                            self.joining_date = data.content.joining_date;
                            self.license_no = data.content.licence_no;
                            self.zip = data.content.zip;
                            self.hourly_labor_rate = data.content.hourly_labor_rate;
                            self.employee_no =  data.content.employee_no;
                            self.shift_hours =  data.content.shift_hours;


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'user-by-id')
                    }
                });
        },
        activityLogs(){

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            self.$root.$emit('activity_log_opted','user',segments[3]);
            self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
            self.activetab = 2;
        },
      },
    };
</script>



// WEBPACK FOOTER //
// src/components/UserView.vue